var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackedByFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 211,
    viewBox: "0 0 340 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 45.4673C162.89 45.4673 209.47 35.5182 209.47 23.2454C209.47 10.9725 162.89 1.02344 105.43 1.02344C47.9705 1.02344 1.39014 10.9725 1.39014 23.2454C1.39014 35.5182 47.9705 45.4673 105.43 45.4673Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 67.69C162.89 67.69 209.47 57.7409 209.47 45.468C209.47 33.1952 162.89 23.2461 105.43 23.2461C47.9705 23.2461 1.39014 33.1952 1.39014 45.468C1.39014 57.7409 47.9705 67.69 105.43 67.69Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 89.9126C162.89 89.9126 209.47 79.9635 209.47 67.6907C209.47 55.4179 162.89 45.4688 105.43 45.4688C47.9705 45.4688 1.39014 55.4179 1.39014 67.6907C1.39014 79.9635 47.9705 89.9126 105.43 89.9126Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 112.131C162.89 112.131 209.47 102.182 209.47 89.9094C209.47 77.6366 162.89 67.6875 105.43 67.6875C47.9705 67.6875 1.39014 77.6366 1.39014 89.9094C1.39014 102.182 47.9705 112.131 105.43 112.131Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 134.354C162.89 134.354 209.47 124.405 209.47 112.132C209.47 99.8593 162.89 89.9102 105.43 89.9102C47.9705 89.9102 1.39014 99.8593 1.39014 112.132C1.39014 124.405 47.9705 134.354 105.43 134.354Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 156.577C162.89 156.577 209.47 146.628 209.47 134.355C209.47 122.082 162.89 112.133 105.43 112.133C47.9705 112.133 1.39014 122.082 1.39014 134.355C1.39014 146.628 47.9705 156.577 105.43 156.577Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 178.803C162.89 178.803 209.47 168.854 209.47 156.581C209.47 144.308 162.89 134.359 105.43 134.359C47.9705 134.359 1.39014 144.308 1.39014 156.581C1.39014 168.854 47.9705 178.803 105.43 178.803Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.43 201.022C162.89 201.022 209.47 191.073 209.47 178.8C209.47 166.527 162.89 156.578 105.43 156.578C47.9705 156.578 1.39014 166.527 1.39014 178.8C1.39014 191.073 47.9705 201.022 105.43 201.022Z",
    stroke: "#3E3C3C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.4396,
    y: 35.1554,
    width: 236.949,
    height: 202.949,
    rx: 17.2245,
    fill: "#252525"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4396,
    y: 35.1554,
    width: 236.949,
    height: 202.949,
    rx: 17.2245,
    stroke: "#141414",
    strokeWidth: 3.05106
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.234 96.6299C161.29 96.6299 158.914 99.0062 158.914 101.95V176.63H225.106C227.343 176.63 229.495 175.741 231.079 174.157L236.442 168.795C238.025 167.211 238.914 165.059 238.914 162.822V96.6299H164.234ZM211.149 106.916L185.128 132.937C184.485 133.579 183.608 133.943 182.698 133.943C181.371 133.943 180.15 133.173 179.583 131.974L169.5 110.662C168.676 108.918 169.95 106.916 171.876 106.916H211.149ZM169.2 166.344V141.029C169.2 139.68 170.292 138.588 171.641 138.588H196.955L169.2 166.344ZM199.053 133.943H190.672L215.89 108.725C217.046 107.569 218.62 106.916 220.257 106.916H228.638L203.42 132.134C202.265 133.29 200.691 133.943 199.053 133.943Z",
    fill: "#00F58C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241.932 15.3936H307.495C323.888 15.3936 337.225 28.73 337.225 45.1236V111.357",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M337.225 113.376C338.339 113.376 339.243 112.473 339.243 111.358C339.243 110.244 338.339 109.341 337.225 109.341C336.11 109.341 335.207 110.244 335.207 111.358C335.207 112.473 336.11 113.376 337.225 113.376Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.932 17.4114C243.046 17.4114 243.949 16.508 243.949 15.3937C243.949 14.2793 243.046 13.376 241.932 13.376C240.817 13.376 239.914 14.2793 239.914 15.3937C239.914 16.508 240.817 17.4114 241.932 17.4114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackedByFuel);
export default __webpack_public_path__ + "static/media/backed-by-fuel.a774c18cce5f56d71fd76835317bb941.svg";
export { ForwardRef as ReactComponent };